const styles = {
  button: {
    cursor: 'pointer',
    display: 'inline-block'
  },
  popperContainer: {
    zIndex: '1000',
    margin: '5px 0',
    visibility: 'hidden'
  },
  opened: {
    visibility: 'visible'
  },
  popper: {
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 11px 39px rgba(0,0,0,0.1)',
    background: '#fff'
  },
  'top-end': {
    marginBottom: '5px'
  },
  'bottom-end': {
    marginTop: '5px'
  }
}

export default styles
